import classNames from "classnames";
import { getCompoundStyle, getStateStyleForBuilder, getStylesFromInteractiveStates } from "../helpers";
import "./style.scss";
import { PaymentGridNode } from "../../build/types";
import { useInteractionStates } from "../../hooks/useInteractionStates";
import { NodeStates } from "../../build/types";
import PaymentButton from "./PaymentButton";

const BuilderPaymentGrid = ({ node, builderProps, disabled, children }: any) => {
    const { attr, id, stateManager, buttonStyles } = node as PaymentGridNode;
    const paymentGridClass = classNames("payment-grid", {
        [`${attr?.className}`]: !!attr?.className,
        ["builder-mode"]: !!builderProps
    });
    const { setElement, states } = useInteractionStates<HTMLDivElement>();

    if (builderProps) {
        const { nodeState, selectCallback, outlineCallback, onDragStart, onDragEnd, otherData } = builderProps;

        const styleWOpacity = {
            ...buttonStyles,
            opacity: 0.5
        };

        return (
            <div
                {...attr}
                className={paymentGridClass}
                style={getCompoundStyle({
                    node,
                    stateStyle: getStateStyleForBuilder(stateManager, nodeState, "attr_style")
                })}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                id={id}
                onDragStart={e => onDragStart?.(e, id)}
                draggable={onDragStart ? "true" : "false"}
                onDragEnd={onDragEnd}
            >
                <PaymentButton title={"Cash"} styles={buttonStyles} />
                <PaymentButton title={"Final tap to pay"} styles={styleWOpacity} />
                <PaymentButton title={"Terminal"} styles={styleWOpacity} />
                {otherData?.paymentGridSettings?.allowCustom && (
                    <>
                        <PaymentButton title={"One custom button"} styles={styleWOpacity} />
                        <PaymentButton title={"Another custom button"} styles={styleWOpacity} />
                    </>
                )}
            </div>
        );
    } else {
        const dynamicGridStyle = getStylesFromInteractiveStates({
            states,
            defaultStyle: getCompoundStyle({ node }),
            stateManager,
            paths: ["attr_style"],
            ...(disabled ? { extraStates: [NodeStates.DISABLED] } : {})
        });

        return (
            <div {...attr} className={paymentGridClass} id={id} ref={setElement} style={dynamicGridStyle}>
                {children}
            </div>
        );
    }
};

export default BuilderPaymentGrid;
